import { setUser } from '@sentry/nextjs';
import { getAuth } from 'firebase/auth';
import { app } from '@/config/firebaseConfig';

export const updateSentryUser = () => {
  const auth = getAuth(app);
  const user = auth.currentUser;

  if (user) {
    setUser({
      id: user.uid,
      email: user.email || undefined,
      username: user.displayName || undefined,
    });
  } else {
    // 当用户登出时，清除 Sentry 用户信息
    setUser(null);
  }
};
